<template>
  <div>
    <ShadowBackground></ShadowBackground>

    <div class="promo_welcome_popup_wrapper">
      <div :style="scaleStyle" class="promo_welcome_popup">
        <WelcomePopupBackground v-if="isLandscape" :height="628" :width="979" />
        <WelcomePopupBackground v-if="!isLandscape" :height="863" :width="520" />
        <img :src="logoLink" alt="" class="promo_welcome_popup_gamzix_logo" />
        <div :style="heightContainer" class="promo_welcome_popup_text_wrapper">
          <slot></slot>
        </div>
        <div class="popup_button_ok" @click="onCloseClick">
          <DefaultButton :text="btnCloseText" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ShadowBackground from '@/components/otherComponents/ShadowBackground.vue';
import DefaultButton from '@/components/otherComponents/DefaultButton.vue';
import WelcomePopupBackground from '@/components/otherComponents/PopupsBackground.vue';

export default Vue.extend({
  name: 'WelcomePopup',
  components: {
    ShadowBackground,
    DefaultButton,
    WelcomePopupBackground
  },
  data: () => ({
    settings: {
      suppressScrollY: false,
      suppressScrollX: false,
      wheelPropagation: false
    }
  }),
  computed: {
    ...mapGetters(['getAppConfiguration']),
    btnCloseText(): string {
      return <string>this.$i18n.t('welcome_popup.play') || '';
    },
    scaleStyle(): { transform: string; top: string; left: string } {
      const offset: { top: number; left: number } = {
        top: this.isLandscape ? 628 / 2 : 863 / 2,
        left: this.isLandscape ? 979 / 2 : 520 / 2
      };
      const scale: number = this.uiScale;
      const addScale: number = this.isLandscape ? 1.5 : 2;

      return {
        transform: `scale(${scale * addScale})`,
        top: `calc(50% - ${offset.top}px)`,
        left: `calc(50% - ${offset.left}px)`
      };
    },
    isLandscape(): boolean {
      return this.getAppConfiguration.isLandscape;
    },
    uiScale(): number {
      return this.getAppConfiguration.scale;
    },
    logoLink(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/logo_gamzix.png`;
    },
    heightContainer(): { height: string } {
      return { height: (this.isLandscape ? 62 : 70) + '%' };
    }
  },
  methods: {
    ...mapActions(['HIDE_WELCOME_POPUP']),
    onCloseClick() {
      this.HIDE_WELCOME_POPUP();
    }
  }
});
</script>

<style scoped>
img {
  max-width: none;
}

.promo_welcome_popup_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.promo_welcome_popup {
  position: absolute;
}

.promo_welcome_popup_text_wrapper {
  overflow-y: auto;
  color: rgb(255, 255, 255);
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 120px;
  width: 90%;
  padding-right: 13px;
}

.promo_welcome_popup_gamzix_logo {
  position: absolute;
  width: 305px;
  left: 0;
  right: 0;
  top: 40px;
  margin-left: auto;
  margin-right: auto;
}
</style>
